const uiConfig = require("../../uiConfig");
const { getMessageForFetchError } = require("../utils/apiError");
const { apiFetch } = require("./apiFetch");

/**
 * Swap a user's login email (Mongo + Firebase + welcome email).
 * @param {{ account_id: string, _id: string, new_email_id: string }} args
 */
async function swapUserEmail({ account_id, _id, new_email_id }) {
  const serverUrl = uiConfig.serverInfo.serverUrl;
  try {
    const resp = await apiFetch(serverUrl + "/swapUserEmail", {
      method: "POST",
      body: JSON.stringify({ account_id, _id, new_email_id }),
    });
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
      const msg = (data && (data.message || data.error)) || "Failed to swap email.";
      throw new Error(msg);
    }
    return data || {};
  } catch (err) {
    const msg = getMessageForFetchError(err);
    throw new Error(msg);
  }
}

module.exports = { swapUserEmail };
